import { Controller } from "@hotwired/stimulus"
import { decryptFileWithMessageKey, importMessageKey } from "../crypto"

// Handles downloading and decrypting E2E encrypted files for external
// recipients. Reads the message key from the URL fragment (#key=...),
// fetches the encrypted ciphertext from the server, decrypts client-side,
// and triggers a browser download.
export default class extends Controller {
  static values = {
    downloadUrl: String,
    iv: String,
    filename: String,
    contentType: String
  }

  async download(event) {
    event.preventDefault()

    try {
      // Extract message key from URL fragment
      const messageKey = await this.getMessageKeyFromFragment()
      if (!messageKey) {
        alert("Decryptiesleutel ontbreekt in de link. Neem contact op met de afzender.")
        return
      }

      // Fetch the encrypted file
      const response = await fetch(this.downloadUrlValue)
      if (!response.ok) {
        throw new Error("Bestand ophalen mislukt.")
      }

      const ciphertext = await response.arrayBuffer()

      // Decrypt with the message key
      const plaintext = await decryptFileWithMessageKey(
        messageKey,
        this.ivValue,
        ciphertext
      )

      // Trigger browser download
      const blob = new Blob([plaintext], { type: this.contentTypeValue || "application/octet-stream" })
      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = this.filenameValue
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error("Decryption failed:", error)
      alert("Ontsleuteling mislukt. Controleer of de link correct is.")
    }
  }

  async getMessageKeyFromFragment() {
    const hash = window.location.hash
    if (!hash || hash.length <= 1) return null

    const params = new URLSearchParams(hash.substring(1))
    const keyBase64 = params.get("key")
    if (!keyBase64) return null

    return await importMessageKey(keyBase64)
  }
}
